import { environment } from '../../../environments/environment';

/**
* State model declaration for store vehicle details
**/
export interface VehicleState {
  vehicles: Array<object>;
  remote: {
    remoteUserGuid: string;
    remoteSubscriptionStatus: string;
  };
}
/**
* Initial State model for store vehicle details
**/
export const initialVehicleState: VehicleState = {
  vehicles: [],
  remote: {
    remoteUserGuid: '',
    remoteSubscriptionStatus: ''
  },
};
